window.Tone = require('tone')
const choo = require('choo')
const html = require('choo/html')
const store = require('./store.js')

const App = require('./app.js')
const app = choo({ hash: true })

app.use(store)

app.route('/', App)
// app.route('/load/:id', App)
app.route('*', App)

app.mount('body')
window.app = app